export default "__VITE_ASSET__23248b7b__"